export const TEXTS = {
  INVOICE_REQUEST_INFO_MODAL_TITLE: 'Запрос отправлен',
  INVOICE_REQUEST_INFO_MODAL_DESCRIPTION: 'Менеджер свяжется с вами в течении рабочего дня',
  INVOICE_REQUEST_INFO_MODAL_OK: 'Хорошо',
  INVOICE_REQUEST_TOAST_WORKDAY_TEXT: 'Менеджер свяжется с вами в течении рабочего дня',
  INVOICE_REQUEST_TOAST_WEEKEND_TEXT: 'Менеджер свяжется с вами в понедельник',
  INVOICE_REQUEST_TOAST_FAIL_TEXT: 'Ошибка выставления счета',
  INVOICE_REQUEST_BACKEND_LIMIT_TEXT: 'Превышено допустимое количество запросов',
};
